<template>
  <v-container fluid>
    <v-card flat class="rounded-lg py-2" height="100%">
      <div class="rowDiv contentCenter px-2">
        <div class="rounded-lg pa-1 pageTitle font-weight-black text-h5" style="width: 200px;">管制區管理</div>
        <div>
          <v-btn depressed  color="success" class="btn_fontSize ml-2" @click="dialogAdd=true">新增</v-btn>
        </div>
        <div>
          <v-btn
            depressed  color="success" class="btn_fontSize ml-2" @click="exportFile" :loading="isExporting"
          >匯出</v-btn>
        </div>
        <v-spacer>
        </v-spacer>
        <div class="text-center mr-5">
          <v-pagination
            circle
            v-model="page"
            :length="pageCount"
            total-visible=7
          ></v-pagination>
        </div>
        <v-divider
          class="tableDivider mr-5"
          vertical
          inset
        >
        </v-divider>
        <div class="text-center mr-5 contentCenter">
          共{{total}}筆
        </div>
        <!-- 每頁顯示筆數 -->
        <div style="width:180px">
          <v-select
            :items="rowsList"
            outlined
            class="rounded-lg"
            dense
            v-model="rows"
            hide-details
            prefix="每頁顯示"
            suffix="筆"
          >
          </v-select>
        </div>
      </div>
      <v-data-table
        class="elevation-1 rounded-lg ml-auto mr-auto mt-2"
        hide-default-footer
        :items="areaList"
        :headers="headers"
        hide-default-header
        :items-per-page="rows"
        :loading="isLoading"
      >
        <template v-slot:header>
          <thead>
            <tr>
              <th
                class="greyTh"
                v-for="header in headers"
                :key="header.value"
              >
                <div
                  :style="'width:'+header.width+'px'"
                  @click="changeSort(header)"
                  class="sortableThDiv"
                >
                  <div class="sortableThDivText">
                    {{header.text}}
                  </div>
                  <div v-if="header.sortable&&sortItem===header.value">
                    <v-icon v-if="sortOrder">mdi-chevron-down</v-icon>
                    <v-icon v-else>mdi-chevron-up</v-icon>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot:item="{ item }">
          <tr>
            <td 
              v-for="header in headers"
              :key="header.value"
              class="tableTD"
            >
              <div v-if="header.value==='actions'">
                <v-icon
                  size = "35"
                  color="primary"
                  style="cursor: pointer;"
                  @click="editData(item)"
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                  size = "35"
                  class="ml-2"
                  color="red"
                  style="cursor: pointer;"
                  @click="openDeleteDialog(item)"
                >
                  mdi-delete
                </v-icon>
              </div>
              <div v-else-if="header.value==='road_code'">
                <div v-for="(road, index) in item.road_code" :key="index">
                  <span>{{road.road_name}}({{road.road_code}})</span>
                </div>
              </div>
              <div v-else>
                {{item[header.value]}}
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          no data available
        </template>
      </v-data-table>
      <!-- 新增編輯dialog -->
      <v-dialog overlay-opacity="0.2" max-width="800px" v-model="dialogAdd" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">{{dialogTitle}}</v-card-title>
          <v-card-text>
            <v-form ref="newDeviceForm">
              <div class="rowDiv contentCenter">
                <div style="width:250px">
                  <v-text-field
                    label="管制區域編號"
                    v-model="selectItem.area_id"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    :rules="rules.content"
                    :disabled="isEdit"
                  ></v-text-field>
                </div>
                <div class="ml-2" style="width:250px">
                  <v-text-field
                    label="管制區域名稱"
                    v-model="selectItem.area_nm"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    :rules="rules.content"
                  ></v-text-field>
                </div>
              </div>
              <div class="rowDiv contentCenter mt-5">
                <div style="width:250px">
                  <v-text-field
                    label="建立時間"
                    v-model="selectItem.create_dt"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    disabled
                  ></v-text-field>
                </div>
                <div class="ml-2" style="width:250px">
                  <v-text-field
                    label="建立人員"
                    v-model="selectItem.create_user"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    disabled
                  ></v-text-field>
                </div>
              </div>
              <div class="rowDiv contentCenter mt-5">
                <div style="width:250px">
                  <v-text-field
                    label="更新時間"
                    v-model="selectItem.update_dt"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    disabled
                  ></v-text-field>
                </div>
                <div class="ml-2" style="width:250px">
                  <v-text-field
                    label="更新人員"
                    v-model="selectItem.update_user"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    disabled
                  ></v-text-field>
                </div>
              </div>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn class="dialogbtn cancelBtnColor" @click="closeDialog">關閉</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn subBtnColor" @click="saveData">確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- 確認刪除管制區dialog -->
      <v-dialog overlay-opacity="0.2" max-width="600px" v-model="dialogDelete" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">刪除管制區域</v-card-title>
          <v-card-text>
            <v-form ref="deleteForm">
              <div class="rowDiv contentCenter">
                <div style="width:180px">
                  <v-text-field
                    label="管制區域編號"
                    v-model="deleteItem.area_id"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    readonly
                  ></v-text-field>
                </div>
                <div style="width:180px" class="ml-2">
                  <v-text-field
                    label="管制區域姓名"
                    v-model="deleteItem.area_nm"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    readonly
                  ></v-text-field>
                </div>
              </div>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn class="dialogbtn cancelBtnColor" @click="closeDeleteDialog">關閉</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn subBtnColor" @click="deleteArea">確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
       <!-- 搜尋 sidebar -->
      <v-navigation-drawer
        app
        clipped
        class="rounded-lg mt-3"
        :width="sidebarWidth"
        height="850"
        permanent
      >
        <div class="rowDiv">
          <v-card-title v-if="sidebarOpen" class="headline font-weight-bold">篩選條件</v-card-title>
          <v-spacer>
          </v-spacer>
          <v-icon
            size = "30"
            style="cursor: pointer;"
            class="mr-5"
            v-if='sidebarOpen'
            @click="sidebarOpen=!sidebarOpen"
          >
            mdi-arrow-expand-left
          </v-icon>
          <v-icon
            size = "30"
            style="cursor: pointer;"
            class="mr-5 mt-5"
            v-else
            @click="sidebarOpen=!sidebarOpen"
          >
            mdi-tune-variant
          </v-icon>
        </div>
        <v-divider></v-divider>
        <div v-if="sidebarOpen">
          <v-card-title style="height:50px;" class="searchTitle">管制區域編號</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-text-field
              v-model="searchAreaId"
              class="rounded-lg"
              dense
              outlined
              hide-details
              clearable
            ></v-text-field>
          </div>
          <v-card-title style="height:50px;" class="searchTitle">管制區域名稱</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-text-field
              v-model="searchAreaNm"
              class="rounded-lg"
              dense
              outlined
              hide-details
              clearable
            ></v-text-field>
          </div>
        </div>
      </v-navigation-drawer>
    </v-card>
  </v-container>
</template>
<script>
// import axios from 'axios'
// import router from '../router'
import Service from '../service/service'
export default {
  name: 'Area_Info',
  data: () => ({
    isLoading: false,
    isExporting: false,
    headers: [
      { text: '管制區域編號', value: 'area_id', sortable: false },
      { text: '管制區域名稱', value: 'area_nm',  sortable: false },
      { text: '', value: 'actions', sortable: false }
    ],
    rows: 10,
    sortItem: 'area_id',
    sortOrder: false,
    total: 0,
    pageCount: 0,
    page: 1,
    rowsList: [10, 20, 30, 40, 50],
    controlPermission: [],
    areaList: [],
    selectItem: {
      area_id: '',
      area_nm: '',
      create_dt: '',
      create_user: '',
      update_dt: '',
      update_user: ''
    },
    dialogAdd: false,
    isEdit: false,
    searchGroupCode: '',
    searchRoadCode: '',
    searchRoadName: '',
    sidebarOpen: true,
    sidebarWidth: 260,
    searchAreaId: '',
    searchAreaNm: '',
    rules: {
      content: [v => !!v || 'Required']
    },
    dialogDelete: false,
    deleteItem: {
      USERID: '',
      USERNAME: ''
    }
  }),
  mounted: function () {
    // this.path = this.$router.currentRoute.path
    // const control = this.permissions.find(x => x.path === this.path)
    // this.controlPermission = control ? control.permission : []
    this.getPageData()
  },
  watch: {
    page () {
      this.getPageData()
    },
    roadPage () {
      this.getRoads()
    },
    sidebarOpen () {
      if (this.sidebarOpen) {
        this.sidebarWidth = 260
      } else {
        this.sidebarWidth = 70
      }
    },
    rows () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    searchAreaId () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    searchAreaNm () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
  },
  props: {
    user: null,
    permissions: null,
    isMobile: null
  },
  computed: {
    order () {
      if (this.sortOrder) {
        return 'desc'
      } else {
        return 'asc'
      }
    },
    dialogTitle () {
      if (this.isEdit) {
        return '編輯管制區'
      } else {
        return '新增管制區'
      }
    }
  },
  methods: {
    showAlert (type, message) {
      var alert = {
        alertType: null,
        alertMessage: '',
        alertIcon: null
      }
      if (type === 'success') {
        alert.alertType = 'success'
        alert.alertIcon = 'mdi-check-circle'
      } else {
        alert.alertType = 'error'
        alert.alertIcon = 'mdi-alert-circle'
      }
      alert.alertMessage = message
      this.$emit('setAlert', alert)
    },
    changeSort (header) {
      if (!header.sortable) return

      if (header.value === this.sortItem) {
        this.sortOrder = !this.sortOrder
      } else {
        this.sortOrder = true
        this.sortItem = header.value
      }
      this.getPageData()
    },
    closeDialog () {
      this.isEdit = false
      this.dialogAdd = false
      this.selectItem = {
        area_id: '',
        area_nm: '',
        create_dt: '',
        create_user: '',
        update_dt: '',
        update_user: ''
      }
      this.getPageData()
    },
    getPageData() {
      this.isLoading = true
      this.areaList = []
      var searchAreaId = {
        name: 'area_id',
        value: this.searchAreaId,
        displayType: 'like'
      }
      var searchAreaNm = {
        name: 'area_nm',
        value: this.searchAreaNm,
        displayType: 'like'
      }
      var wheres = [searchAreaId, searchAreaNm]
      var parm = {
        page: this.page,
        rows: this.rows,
        order: this.order,
        sort: this.sortItem,
        wheres: JSON.stringify(wheres),
        url: 'area_info/getPageData'
      }
      Service.getPageData(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || response.data.status !== 0) {
            this.showAlert('error', response.data.message)
          } else {
            this.total = response.data.total
            this.pageCount = Math.ceil(this.total / this.rows)
            this.areaList = response.data.rows
          }
        })
      .finally(() => {
        this.isLoading = false
      })
    },
    editData (item) {
      this.selectItem = item
      this.isEdit = true
      this.dialogAdd = true
    },
    saveData () {
      if (this.$refs.newDeviceForm.validate()) {
        var url = this.isEdit ? '/area_info/update' : '/area_info/Add'
        Service.updateData(this.selectItem, url)
          .then((response) => {
            // console.log(response)
            if (response.status !== 200 || !response.data.status) {
              this.showAlert('error', response.data.message)
            } else {
              this.showAlert('success', response.data.message)
              this.getPageData()
              this.closeDialog()
            }
          })
      }
    },
    openDeleteDialog (item) {
      this.dialogDelete = true
      this.deleteItem = {
          area_id: item.area_id,
          area_nm: item.area_nm
        }
    },
    closeDeleteDialog () {
      this.dialogDelete = false
      if (this.$refs.deleteForm) {
        this.$refs.deleteForm.resetValidation()
        this.deleteItem = {
          area_id: '',
          area_nm: ''
        }
      }
    },
    deleteArea () {
      if (this.$refs.deleteForm) {
        this.$refs.deleteForm.resetValidation()
        
        var deleteList = []
        deleteList.push(this.deleteItem.area_id)
        const url = '/area_info/del'
        Service.deleteData(deleteList, url)
          .then((response) => {
            // console.log(response)
            if (response.status !== 200 || !response.data.status) {
              this.showAlert('error', response.data.message)
            } else {
              this.showAlert('success', response.data.message)
              this.getPageData()
              this.dialogDelete = false
            }
          })
      }
    },
    exportFile () {
      this.isExporting = true
      var searchAreaId = {
        name: 'area_id',
        value: this.searchAreaId,
        displayType: 'like'
      }
      var searchAreaNm = {
        name: 'area_nm',
        value: this.searchAreaNm,
        displayType: 'like'
      }
      var wheres = [searchAreaId, searchAreaNm]
      var parm = {
        order: this.order,
        sort: this.sortItem,
        wheres: JSON.stringify(wheres),
        url: 'area_info/Export'
      }
      Service.exportFile(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200) {
            this.showAlert('error', response.data.message)
          } else {
            var filename = '管制區管理.xlsx'
            var downloadURL = ''
            var binaryData = []
            binaryData.push(response.data)
            downloadURL = URL.createObjectURL(new Blob(binaryData, { type: 'application/octet-stream' }))
            var link = document.createElement('a')
            link.href = downloadURL
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
            link = null
          }
        })
      .finally(() => {
        this.isExporting = false
      })
    },
  }
}
</script>
